import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Dashboard.css';
import '../styles/main.css';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiPost, apiGet, apiDelete, apiPut } from '../services/api';

const Setting = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    smtpName: '',
    smtpPort: '',
  });

  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      setLoading(true);
      const response = await apiGet('/User/GetAll');

      if (response?.data) {
        const transformedData = response.data
          .map((item) => ({
            id: item.appSettingID,
            email: item.emailID || '',
            password: item.password || '',
            smtp: item.smtp || '',
            port: item.portNo || '',
            mailOn: item.isActive ?? false,
            status: item.isActive ? 'Active' : 'Inactive',
          }))
          .sort((a, b) => b.id - a.id);

        setEntries(transformedData);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      toast.error('Failed to load email configurations');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (id) => {
    const entryToEdit = entries.find(entry => entry.id === id);
    if (entryToEdit) {
      setFormData({
        email: entryToEdit.email,
        password: entryToEdit.password,
        smtpName: entryToEdit.smtp,
        smtpPort: entryToEdit.port
      });
      setEditingId(id);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      emailID: formData.email,
      password: formData.password,
      smtp: formData.smtpName,
      portNo: formData.smtpPort,
      createdByID: 1,
      createdDate: new Date().toISOString(),
    };

    try {
      let response;

      if (editingId) {
        response = await apiPut(`/User/Update/${editingId}`, payload);
      } else {
        response = await apiPost('/User/Create', payload);
      }

      console.log('Add/Update Response:', response);

      toast.success(`Email configuration ${editingId ? 'updated' : 'added'} successfully!`);

      await fetchUserData();
      setFormData({ email: '', password: '', smtpName: '', smtpPort: '' });
      setEditingId(null);

    } catch (error) {
      console.error('API error:', error);
      toast.error(`An error occurred while ${editingId ? 'updating' : 'adding'} the email settings.`);
    }
  };



  const handleDelete = async (id) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this email configuration?');

    if (!isConfirmed) return;
    try {
      const response = await apiDelete(`/User/Delete/${id}`);
      console.log('Delete response:', response);
      toast.success('Configuration deleted successfully!');
      await fetchUserData();

    } catch (error) {
      console.error('Delete error:', error);
      toast.error('An error occurred while deleting the configuration.');
    }
  };

  const toggleMailOnOff = async (appSettingID) => {
    try {
      const response = await apiPost('/User/ToggleActive', appSettingID); // Just send number, not object

      if (response.isSuccess) {
        toast.success(response.message || 'Email service updated');

        // Update local state to reflect the change in UI (optional)
        setEntries((prev) =>
          prev.map((entry) =>
            entry.id === appSettingID ? { ...entry, mailOn: !entry.mailOn } : entry
          )
        );
      } else {
        toast.error(response.message || 'Failed to update email service');
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
    }
  };




  const handleClear = () => {
    setFormData({ email: '', password: '', smtpName: '', smtpPort: '' });
    setEditingId(null);
  };

  // const toggleMailOnOff = (id) => {
  //   setEntries((prev) =>
  //     prev.map((entry) =>
  //       entry.id === id ? { ...entry, mailOn: !entry.mailOn } : entry
  //     )
  //   );
  // };

  const columns = [
    {
      name: 'ID', selector: (row) => row.id, sortable: true,
      width: '100px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },

    },
    {
      name: 'Email ID', selector: (row) => row.email, sortable: true,
      width: '170px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },
    },
    {
      name: 'Password', selector: (row) => row.password,
      width: '150px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },
    },
    {
      name: 'SMTP', selector: (row) => row.smtp,
       width: '150px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },

    },
    {
      name: 'Port No', selector: (row) => row.port,
      width: '140px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },

    },
    {
      name: 'Mail ON/OFF',
      cell: (row) => (
        <button
          className={`btn btn-sm ${row.mailOn ? 'btn-outline-success' : 'btn-outline-danger'}`}
          onClick={() => toggleMailOnOff(row.id)}
        >
          {row.mailOn ? 'ON' : 'OFF'}
        </button>
      ),
      width: '140px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },
    },
    {
      name: 'Status', selector: (row) => row.status,
      width: '150px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },

    },
    {
      name: 'Action',

      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-outline-warning custompadding btn-sm me-2"
            onClick={() => handleEdit(row.id)}
          >
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="btn btn-outline-danger custompadding btn-sm me-2"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '140px',
      center: true,


    },
  ];

  return (
    <>
      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="d-flex justify-content-center gap-3">
            <Link to="/dashboard/setting">
              <Button variant="primary" className="btn-btn-primary">Change Email and SMTP Port</Button>
            </Link>
            <Link to="/dashboard/Changemasterheader">
              <Button variant="light" className="btn-btn-sechover">Change Master Header</Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <div className="row custombox">
          <div className="rounded p-4 mb-4">
            <div className="text-center customheader">
              <h5 className="mb-0 page-heading">Mail Settings</h5>
            </div>

            <form onSubmit={handleSubmit} className="row">
              <div className="col-md-6 mb-4">
                <label>Email ID</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-4">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-4">
                <label>SMTP Name</label>
                <input
                  type="text"
                  name="smtpName"
                  className="form-control"
                  value={formData.smtpName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6 mb-4">
                <label>SMTP Port Number</label>
                <input
                  type="number"
                  name="smtpPort"
                  className="form-control"
                  value={formData.smtpPort}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="text-center mt-4">
                <Button type="submit" variant="primary" className="px-4 me-3 btn-fontweight btn-btn-primary">
                  {editingId ? 'Update' : 'Submit'}
                </Button>
                <Button type="button" variant="secondary" className="px-4 me-3 btn-fontweight" onClick={handleClear}>
                  Clear
                </Button>
              </div>
            </form>
          </div>
        </div>

        <div className="row mt-4">
          <div className="card shadow-sm rounded-4 py-4 px-2 border-0 bg-white mb-custom">
            <h2 className="text-xl font-bold mb-4 page-heading">SMTP Configuration List</h2>
            <DataTable
              columns={columns}

              data={entries.map((dept, idx) => ({
                ...dept,
                _rowIndex: idx,
              }))}
              progressPending={loading}
              pagination

              striped
              responsive
              className="p-datatable-striped customuser-data-table customarchive-data-table   dashboard-table"

              customStyles={{
                table: {
                  style: {

                    fontWeight: '600',
                    fontSize: '14px',
                    backgroundColor: '#f8f9fa',
                    textAlign: 'center',
                  },
                },
                headRow: {
                  style: {
                    backgroundColor: "#04364A!important",
                    minHeight: "48px",
                  },
                },
                headCells: {
                  style: {
                    padding: "10px 14px",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: "white",
                    textTransform: "uppercase",
                    textAlign: columns.name === "Issue/Action/Decision" ? "center" : "left",
                  },
                },
                rows: {
                  style: {
                    borderBottom: "1px solid #fdfdfd",
                    "&:hover": {
                      backgroundColor: "#fdfdfd",
                    },
                  },
                },
                cells: {
                  style: {
                    padding: "10px 14px",
                    fontSize: "14px",
                    color: "#334155",
                  },
                },
              }}
              conditionalRowStyles={[
                {
                  when: (row) => row._rowIndex % 2 === 0,
                  style: { backgroundColor: '#f2f2f2' },
                },
                {
                  when: (row) => row._rowIndex % 2 !== 0,
                  style: { backgroundColor: '#ffffff' },
                },
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;